module.exports = __webpack_public_path__ + "img/a.bc5d2ba2.jpg";